import { ModelBase } from 'store/model-base';

import { QuickpayLookupErrorCode } from 'my-account/constants';
import { HopInit } from 'store/hop/models';

export class QuickpaymentMdnLookup extends ModelBase {
    public static storeName: string = 'quickpaymentMdnLookup';

    public balance: number;
    public maskedMDN: string;
    public authGuid: string;
    public hopInitDetails: HopInit;
    public errorCodes: QuickpayLookupError[];

    public accountNotFound: boolean;
    public multipleAccountFound: boolean;
    public noBalanceDue: boolean;
    public tallyAttempts: boolean;
    public maxoutAttempts: boolean;
    public isCpc: boolean;
    public isQuickPay: boolean;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.errorCodes = data.errorCodes || [];
        data.isQuickPay = data.hopInitDetails && data.hopInitDetails.comcast_applicationChannel === 'XFINITY_MOBILE_LITE_TKN';

        data.accountNotFound = data.errorCodes.find((error: QuickpayLookupError) => error.errorCode === QuickpayLookupErrorCode.QP_1100
            || error.errorCode === QuickpayLookupErrorCode.QP_1200 || error.errorCode === QuickpayLookupErrorCode.QP_1300 || error.errorCode === QuickpayLookupErrorCode.QP_1400);
        data.multipleAccountFound = data.errorCodes && data.errorCodes.find((error: QuickpayLookupError) => error.errorCode === QuickpayLookupErrorCode.QP_1500);
        data.noBalanceDue = data.errorCodes && data.errorCodes.find((error: QuickpayLookupError) => error.errorCode === QuickpayLookupErrorCode.QP_1700);
        data.tallyAttempts = data.errorCodes && data.errorCodes.find((error: QuickpayLookupError) => error.errorCode === QuickpayLookupErrorCode.QP_1800);
        data.maxoutAttempts = data.errorCodes && data.errorCodes.find((error: QuickpayLookupError) => error.errorCode === QuickpayLookupErrorCode.QP_1900);

        return super.create<T>(data);
    }
}
